import { render } from "./Children.vue?vue&type=template&id=0fff03e7&scoped=true"
import script from "./Children.vue?vue&type=script&lang=ts"
export * from "./Children.vue?vue&type=script&lang=ts"

import "./Children.vue?vue&type=style&index=0&id=0fff03e7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0fff03e7"

export default script